module.exports = __webpack_public_path__ + "static/media/product.e7372132.svg";